import * as React from 'react';
import './PVAContainer.scss';
import './PVAContainerSimple.css';

interface PVAContainerProps {
    topic?: string;
    title: string;
    defaultOpen?: boolean;
    children?: React.ReactNode;
}

export class PVAContainerSimple extends React.Component<PVAContainerProps, { open: boolean }> {
    constructor(props: PVAContainerProps) {
        super(props);

        var open = true;
        if (this.props.defaultOpen !== undefined) {
            open = this.props.defaultOpen;
        }
        this.state = {
            open: open
        };
    }

    render() {
        const { open } = this.state;
        return (
            <div className={"component-PVAContainer-Simple" + (open ? " open" : " closed")}>
                <div className="pva-accordion" onClick={(e) => { this.setState({ open: !this.state.open }); }}>
                    <div className="header">
                        <div className="topic">
                            {this.props.topic}
                        </div>
                        <div className="title">
                            {this.props.title}
                        </div>
                    </div>
                    <div className="chevron-container">
                        <span className="glyphicon glyphicon-triangle-bottom chevron" />
                    </div>
                </div>
                <div className="body">
                    {this.props.children}
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/reports/blocks/PVAContainerSimple.tsx